import * as React from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
    inputSize?: 'default' | 'lg';
    font?: 'default' | 'mono';
    appearance?: 'default' | 'code' | 'leadingIcon';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, inputSize = 'default', font = 'default', appearance = 'default', ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'flex w-full border border-input bg-background px-4 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    inputSize === 'default' ? 'h-9 rounded-full' : 'h-11 rounded-xl',
                    font === 'mono' && 'font-mono text-sm',
                    appearance === 'code' && 'font-mono text-sm',
                    appearance === 'leadingIcon' && 'pl-9',
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);
Input.displayName = 'Input';

export { Input };
export type { InputProps };
